import apiClient from '../../../config/api';
import { PATH } from '../../../config/api/path';
import { IResponse } from '../../../interfaces/common';
import { UNKNOWN_ERROR } from '../../../utils/constants/strings';
import { transformResponseToIResponse } from '../../../utils/helpers/function';

/**
 * Auth service
 */
const AuthService = {
  login: async (value: LogInRequest): Promise<IResponse> => {
    const url = PATH.AUTH.LOGIN;
    try {
      const response = await apiClient.post<IResponse>(url, value);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },
  logout: async (): Promise<IResponse> => {
    const url = PATH.AUTH.LOGOUT;
    try {
      const response = await apiClient.post<IResponse>(url, {});
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },
  /**
   * Handle check auth
   * @returns
   */
  checkAuth: async (): Promise<IResponse> => {
    const url = PATH.AUTH.CHECK_AUTH;
    try {
      const response = await apiClient.get<IResponse>(url);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },

  /**
   * Handle Forgot Password
   * @param value
   * @returns
   */
  forgotPassword: async (value: ForgotPasswordRequest): Promise<IResponse> => {
    const url = PATH.AUTH.FORGOT_PASSWORD;
    try {
      const response = await apiClient.post<IResponse>(url, value);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },

  /**
   * Handle check token reset password
   * @param checkToken string
   * @returns
   */
  checkTokenResetPassword: async (checkToken: string): Promise<IResponse> => {
    const url = PATH.AUTH.CHECK_TOKEN_RESET_PASSWORD + `/${checkToken}`;
    try {
      const response = await apiClient.get<IResponse>(url);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },

  /**
   * Handle reset password
   * @param value ResetPasswordRequest
   * @returns
   */
  resetPassword: async (value: ResetPasswordRequest): Promise<IResponse> => {
    const url = PATH.AUTH.RESET_PASSWORD;
    try {
      const response = await apiClient.post<IResponse>(url, value);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },

  /**
   * Handle change password
   * @param id string
   * @param checkToken string
   * @param value ResetPasswordRequest
   * @returns
   */
  changePassword: async (value: ResetPasswordRequest): Promise<IResponse> => {
    const url = PATH.AUTH.CHANGE_PASSWORD;
    try {
      const response = await apiClient.post<IResponse>(url, value);
      return transformResponseToIResponse(response);
    } catch (e: unknown) {
      return {
        data: null,
        isError: true,
        message: e instanceof Error ? e.message : UNKNOWN_ERROR,
      };
    }
  },
};

export default AuthService;
